// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html,
body {
    height: 100%;
}

#layout {
    display: flex;
    flex-direction: column;
}

#page {
    overflow-y: auto;
}

main {
    /*display: flex;
            justify-content: center;
            flex: auto;*/
    display: flex;
    flex: 1 auto;
}

.centered-layout {
    max-width: 960px;
    align-self: center;
    width: 100%;
    height: 100%;
}

.padding {
    overflow-y: auto;
}

.profile-style #main-content {
    padding: 0;
}

#main-content .panel-box-content {
    position: relative;
}

header.toolbar {
    padding: 0px 1rem;
    height: 60px;
    line-height: 59px;
    align-items: center;
    border-bottom: 1px solid var(--lighter);
}

header .toolbar-section {
    width: 33.33333%;
    height: 100%;
}
.language-selector {
    line-height: 30px;
}

header .toolbar-section:not(:first-child):not(:last-child) {
    justify-content: center;
}

header .toolbar-section:last-child {
    justify-content: flex-end;
}

header .toolbar-title {
    align-items: center;
    display: flex;
}

header .toolbar-title img {
    max-height: 80%;
}

.spaced-tabs > * {
    padding: 0 1rem;
}

.hero {
    padding: 5rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: var(--accent-1);
    border-radius: 0.1rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    height: 100%;
    transition: 0.2s;
}

.library .hero:hover {
    transform: translateY(-0.3rem);
}

.hero-content {
    padding: 0 4rem;
    color: var(--font-light);
    position: relative;
    z-index: 3;
    max-width: 60%;
}

.hero-content h1 {
    color: var(--white);
    margin: 1rem 0 2rem 0;
}

.hero-content h1:first-child {
    margin-top: 2rem;
}

.course-page-header .hero-content {
    padding: 0;
}

.hero-img {
    background: var(--accent-1);
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: right;
}

.hero-img-mask {
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: -65%;
    transform: rotate(70deg);
    background: var(--white);
    z-index: 2;
}

.hero-img-mask:last-child {
    transform: rotate(95deg);
    opacity: 0.5;
    z-index: 1;
    left: -67%;
    top: -50%;
}

.course-page-header .hero-img-mask {
    left: -70%;
}

.course-page-header .hero-img-mask:last-child {
    left: -74%;
}

.course-box-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.8rem;
    margin-right: -0.8rem;
    justify-content: flex-start;
}

.course-box-list > a {
    width: 33.33333%;
    min-width: 250px;
    padding: 0.8rem;
    box-sizing: border-box;
    transition: 0.2s;
    max-width: 330px;
    flex-grow: 1;
}
.course-box-list > a:hover {
    transform: translateY(-0.3rem);
}

.course-box-list > a > div {
    border-radius: 0.1rem;
    min-height: 300px;
    height: 100%;
    background: var(--lighter);
    overflow: hidden;
}

.course-box-list > a > div .padding {
    padding: 0.8rem;
}

.course-box-list > a > div .img {
    width: 100%;
    height: 165px;
    background-size: cover !important;
    background-position: center !important;
    background: var(--light);
}

.course-box-list .form-buttons .label-circle {
    line-height: 30px;
    white-space: nowrap;
}

.course-progress-bar {
    position: relative;
    height: 5px;
    background: var(--light);
}

.course-progress-bar > div {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
}

.unit-status-icon {
    padding: 0.4rem;
    margin-right: 0.8rem;
    background: var(--light);
    color: var(--lighter);
    align-items: center;
    display: flex;
}

.unit-status-icon.passed {
    background: var(--passed);
}

.unit-status-icon.failed {
    background: var(--failed);
}

.unit-status-icon.warn {
    background: var(--warn);
}

.unit-status-icon.loading {
    width: 2rem;
    justify-content: center;
}

.unit-status-icon i {
    font-size: 2rem;
}

.unit-status-icon.loading > i::after {
    border: 2px solid var(--lighter);
    border-right-color: transparent;
    border-top-color: transparent;
    height: 1rem;
    width: 1rem;
    margin-top: -0.5rem;
    display: block;
    margin: 0 auto;
}
.course-page-header {
    height: 300px;
    position: relative;
    background: var(--accent-1);
}

.course-content-section {
    flex: 80%;
}
.course-content-section .big-number-list > * {
    padding: 0.8rem;
    margin-right: 1.6rem;
    border-radius: 0.1rem;
    background: var(--lighter);
}

.course-content-section .big-number-list .padding {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.course-content-section .big-number {
    color: var(--font-light);
}

.course-info-section {
    flex: 40%;
}

#player {
    background: var(--bg);
    position: fixed;
    top: 0rem;
    left: 0rem;
    bottom: 0rem;
    right: 0rem;
    z-index: 99;
    display: flex;
    flex-direction: column;
}

#player-bg {
    position: fixed;
    background: var(--dark);
    opacity: 0.7;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 98;
}

#player > iframe,
#player > embed {
    flex: auto;
}

.close-btn {
    position: absolute;
    top: 0.4rem;
    left: 0.4rem;
    background: var(--accent-1);
    padding: 0.2rem;
    color: var(--white);
    cursor: pointer;
    display: block;
}

.close-btn::before {
    display: block;
}

.close-btn:hover::before {
    content: "Save & Close";
    font-family: sans-serif;
    font-size: .9rem;
    padding: 0.2rem .4rem;
}

#form {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
}

#form .form-bg {
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: var(--bg);
    opacity: 0.9;
}

#form .form-container {
    width: 400px;
    max-height: 80%;
    margin: 0 auto;
    margin-top: 5%;
    background: var(--bg);
    padding: 0.8rem;
    border: 1px solid var(--dark);
    z-index: 99;
    position: relative;
    overflow-y: auto;
}

.sessions-list > div:not(:last-child) {
    margin-bottom: 2rem;
}

.sessions-list > div:hover {
    background: var(--lighter);
}

.date-number {
    margin-right: 1.2rem;
    color: var(--dark);
    text-align: center;
    width: 3.6rem;
    min-width: 3.6rem;
    background: var(--lighter);
    height: 3.6rem;
    font-size: 2rem;
    line-height: 1.2;
    border-radius: 0.2rem;
}

.date-number div {
    font-size: 0.6rem;
}

.sessions-list > div:hover .date-number {
    background: var(--bg);
}
.ul-no-style{
    list-style: none;
}
.list{
    width: 100%;
    background-color: #ffffff;
    max-height: 100px;
    overflow: auto;
}
.list-items{
    padding: 10px 5px;
    font-size: .75rem;
 }
.list-items:hover{
    padding: 10px 5px;
    background-color: #dddddd;
}
.muted {
    color: #858896;
}

.dropdown:hover .dropdown-list {
    max-height: 320px;
    overflow-y: auto;
}

/* The language selector manages its own (viewport-based) height in styles.css
   / responsive-styles.css. Keep the hover state identical to the resting state
   so the list stays scrollable without resizing when the mouse enters/leaves. */
.dropdown:hover .dropdown-list.lang-selector {
    max-height: 60vh;
    overflow-y: auto;
}

@media only screen and (max-width: 820px) {
    .dropdown:hover .dropdown-list.lang-selector {
        max-height: 77vh;
    }
}

/* Dropdown form field (dropdownsingle / dropdownmulti) in the learner form modal */
.dropdown-field {
    width: 100%;
    padding: 0;
}
.dropdown-field .dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left;
}
.dropdown-field .dropdown-trigger.dropdown-placeholder .dropdown-trigger-label {
    color: #858896;
}
/* Label shows the selected value(s) on a single line; the comma-separated multi-select
   list is clipped with an ellipsis when it doesn't fit (the component then swaps in an
   "N selected" summary via the hidden sizer below). min-width:0 lets it shrink inside
   the flex trigger. */
.dropdown-field .dropdown-trigger-label {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* Off-screen sizer holding the full comma-separated list at its natural width so the
   component can measure whether it would fit; never visible and never affects layout. */
.dropdown-field .dropdown-label-sizer {
    position: absolute;
    left: 0;
    top: 0;
    visibility: hidden;
    white-space: nowrap;
    pointer-events: none;
}
/* CSS-drawn caret so the arrow renders regardless of icon-font coverage. */
.dropdown-field .dropdown-chevron {
    flex: 0 0 auto;
    margin-left: 0.5rem;
    width: 0;
    height: 0;
    border-left: 0.3125rem solid transparent;
    border-right: 0.3125rem solid transparent;
    border-top: 0.375rem solid currentColor;
    transition: transform 0.15s ease;
}
.dropdown-field.open .dropdown-chevron {
    transform: rotate(180deg);
}
/* This field opens on click (.open), not on hover. Neutralise the base hover rule. */
.dropdown-field:hover .dropdown-list {
    display: none;
}
.dropdown-field.open .dropdown-list {
    display: block;
    max-height: 320px;
    overflow-y: auto;
}
.dropdown-field .dropdown-search {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    border: none;
    border-bottom: 1px solid var(--accent-1);
}
.dropdown-field.open .dropdown-list > div {
    display: flex;
    align-items: center;
}
/* Review mode: the menu can be opened to inspect selections, but options are not clickable. */
.dropdown-field.open .dropdown-list > div.read-only {
    cursor: default;
}
/* The read-only form disables pointer events on all inputs/buttons (.disable-fields). The
   dropdown is the exception: reviewers must be able to open it and search to see the full
   list of selected options, so re-enable interaction on the trigger and search input. */
.disable-fields .dropdown-field .dropdown-trigger,
.disable-fields .dropdown-field .dropdown-search {
    pointer-events: auto;
}
.review-notice {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    /* Pull up under the tile (tile has margin-bottom: 1rem) and match its right margin */
    margin: -0.5rem 2rem 1rem 0;
    border-radius: 6px;
    background: #fff6e5 !important;
    border: 1px solid var(--warn);
    color: inherit;
    font-size: 0.85rem;
    line-height: 1.35;
}

.review-notice i {
    color: var(--warn);
    font-size: 1.1rem;
    flex-shrink: 0;
    line-height: 1.2;
}

.review-notice__title {
    font-weight: 600;
}

.review-badge {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    padding: 0.15rem 0.6rem;
    border-radius: 4px;
    background: var(--warn);
    color: #4a3200;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/public-styles.css"],"names":[],"mappings":";AACA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;;wBAEoB;IACpB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,wBAAwB;IACxB,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,MAAM;AACV;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;AACb;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;IACP,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,iBAAiB;CACpB;AACD;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;gFAEgF;AAChF;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,mFAAmF;AACnF;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;;;sBAGsB;AACtB;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;wFACwF;AACxF;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;AACA,2EAA2E;AAC3E;IACI,cAAc;IACd,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,yCAAyC;IACzC,uCAAuC;IACvC,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA,qFAAqF;AACrF;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA,8FAA8F;AAC9F;IACI,eAAe;AACnB;AACA;;wFAEwF;AACxF;;IAEI,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,qFAAqF;IACrF,2BAA2B;IAC3B,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B","sourcesContent":["\nhtml,\nbody {\n    height: 100%;\n}\n\n#layout {\n    display: flex;\n    flex-direction: column;\n}\n\n#page {\n    overflow-y: auto;\n}\n\nmain {\n    /*display: flex;\n            justify-content: center;\n            flex: auto;*/\n    display: flex;\n    flex: 1 auto;\n}\n\n.centered-layout {\n    max-width: 960px;\n    align-self: center;\n    width: 100%;\n    height: 100%;\n}\n\n.padding {\n    overflow-y: auto;\n}\n\n.profile-style #main-content {\n    padding: 0;\n}\n\n#main-content .panel-box-content {\n    position: relative;\n}\n\nheader.toolbar {\n    padding: 0px 1rem;\n    height: 60px;\n    line-height: 59px;\n    align-items: center;\n    border-bottom: 1px solid var(--lighter);\n}\n\nheader .toolbar-section {\n    width: 33.33333%;\n    height: 100%;\n}\n.language-selector {\n    line-height: 30px;\n}\n\nheader .toolbar-section:not(:first-child):not(:last-child) {\n    justify-content: center;\n}\n\nheader .toolbar-section:last-child {\n    justify-content: flex-end;\n}\n\nheader .toolbar-title {\n    align-items: center;\n    display: flex;\n}\n\nheader .toolbar-title img {\n    max-height: 80%;\n}\n\n.spaced-tabs > * {\n    padding: 0 1rem;\n}\n\n.hero {\n    padding: 5rem 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: var(--accent-1);\n    border-radius: 0.1rem;\n    position: relative;\n    overflow: hidden;\n    box-sizing: border-box;\n    height: 100%;\n    transition: 0.2s;\n}\n\n.library .hero:hover {\n    transform: translateY(-0.3rem);\n}\n\n.hero-content {\n    padding: 0 4rem;\n    color: var(--font-light);\n    position: relative;\n    z-index: 3;\n    max-width: 60%;\n}\n\n.hero-content h1 {\n    color: var(--white);\n    margin: 1rem 0 2rem 0;\n}\n\n.hero-content h1:first-child {\n    margin-top: 2rem;\n}\n\n.course-page-header .hero-content {\n    padding: 0;\n}\n\n.hero-img {\n    background: var(--accent-1);\n    width: 50%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position-y: center;\n    background-position-x: right;\n}\n\n.hero-img-mask {\n    width: 200%;\n    height: 200%;\n    position: absolute;\n    top: 0;\n    left: -65%;\n    transform: rotate(70deg);\n    background: var(--white);\n    z-index: 2;\n}\n\n.hero-img-mask:last-child {\n    transform: rotate(95deg);\n    opacity: 0.5;\n    z-index: 1;\n    left: -67%;\n    top: -50%;\n}\n\n.course-page-header .hero-img-mask {\n    left: -70%;\n}\n\n.course-page-header .hero-img-mask:last-child {\n    left: -74%;\n}\n\n.course-box-list {\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -0.8rem;\n    margin-right: -0.8rem;\n    justify-content: flex-start;\n}\n\n.course-box-list > a {\n    width: 33.33333%;\n    min-width: 250px;\n    padding: 0.8rem;\n    box-sizing: border-box;\n    transition: 0.2s;\n    max-width: 330px;\n    flex-grow: 1;\n}\n.course-box-list > a:hover {\n    transform: translateY(-0.3rem);\n}\n\n.course-box-list > a > div {\n    border-radius: 0.1rem;\n    min-height: 300px;\n    height: 100%;\n    background: var(--lighter);\n    overflow: hidden;\n}\n\n.course-box-list > a > div .padding {\n    padding: 0.8rem;\n}\n\n.course-box-list > a > div .img {\n    width: 100%;\n    height: 165px;\n    background-size: cover !important;\n    background-position: center !important;\n    background: var(--light);\n}\n\n.course-box-list .form-buttons .label-circle {\n    line-height: 30px;\n    white-space: nowrap;\n}\n\n.course-progress-bar {\n    position: relative;\n    height: 5px;\n    background: var(--light);\n}\n\n.course-progress-bar > div {\n    position: absolute;\n    height: 100%;\n    left: 0;\n    top: 0;\n}\n\n.unit-status-icon {\n    padding: 0.4rem;\n    margin-right: 0.8rem;\n    background: var(--light);\n    color: var(--lighter);\n    align-items: center;\n    display: flex;\n}\n\n.unit-status-icon.passed {\n    background: var(--passed);\n}\n\n.unit-status-icon.failed {\n    background: var(--failed);\n}\n\n.unit-status-icon.warn {\n    background: var(--warn);\n}\n\n.unit-status-icon.loading {\n    width: 2rem;\n    justify-content: center;\n}\n\n.unit-status-icon i {\n    font-size: 2rem;\n}\n\n.unit-status-icon.loading > i::after {\n    border: 2px solid var(--lighter);\n    border-right-color: transparent;\n    border-top-color: transparent;\n    height: 1rem;\n    width: 1rem;\n    margin-top: -0.5rem;\n    display: block;\n    margin: 0 auto;\n}\n.course-page-header {\n    height: 300px;\n    position: relative;\n    background: var(--accent-1);\n}\n\n.course-content-section {\n    flex: 80%;\n}\n.course-content-section .big-number-list > * {\n    padding: 0.8rem;\n    margin-right: 1.6rem;\n    border-radius: 0.1rem;\n    background: var(--lighter);\n}\n\n.course-content-section .big-number-list .padding {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.course-content-section .big-number {\n    color: var(--font-light);\n}\n\n.course-info-section {\n    flex: 40%;\n}\n\n#player {\n    background: var(--bg);\n    position: fixed;\n    top: 0rem;\n    left: 0rem;\n    bottom: 0rem;\n    right: 0rem;\n    z-index: 99;\n    display: flex;\n    flex-direction: column;\n}\n\n#player-bg {\n    position: fixed;\n    background: var(--dark);\n    opacity: 0.7;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 98;\n}\n\n#player > iframe,\n#player > embed {\n    flex: auto;\n}\n\n.close-btn {\n    position: absolute;\n    top: 0.4rem;\n    left: 0.4rem;\n    background: var(--accent-1);\n    padding: 0.2rem;\n    color: var(--white);\n    cursor: pointer;\n    display: block;\n}\n\n.close-btn::before {\n    display: block;\n}\n\n.close-btn:hover::before {\n    content: \"Save & Close\";\n    font-family: sans-serif;\n    font-size: .9rem;\n    padding: 0.2rem .4rem;\n}\n\n#form {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 99;\n}\n\n#form .form-bg {\n    position: fixed;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    background: var(--bg);\n    opacity: 0.9;\n}\n\n#form .form-container {\n    width: 400px;\n    max-height: 80%;\n    margin: 0 auto;\n    margin-top: 5%;\n    background: var(--bg);\n    padding: 0.8rem;\n    border: 1px solid var(--dark);\n    z-index: 99;\n    position: relative;\n    overflow-y: auto;\n}\n\n.sessions-list > div:not(:last-child) {\n    margin-bottom: 2rem;\n}\n\n.sessions-list > div:hover {\n    background: var(--lighter);\n}\n\n.date-number {\n    margin-right: 1.2rem;\n    color: var(--dark);\n    text-align: center;\n    width: 3.6rem;\n    min-width: 3.6rem;\n    background: var(--lighter);\n    height: 3.6rem;\n    font-size: 2rem;\n    line-height: 1.2;\n    border-radius: 0.2rem;\n}\n\n.date-number div {\n    font-size: 0.6rem;\n}\n\n.sessions-list > div:hover .date-number {\n    background: var(--bg);\n}\n.ul-no-style{\n    list-style: none;\n}\n.list{\n    width: 100%;\n    background-color: #ffffff;\n    max-height: 100px;\n    overflow: auto;\n}\n.list-items{\n    padding: 10px 5px;\n    font-size: .75rem;\n }\n.list-items:hover{\n    padding: 10px 5px;\n    background-color: #dddddd;\n}\n.muted {\n    color: #858896;\n}\n\n.dropdown:hover .dropdown-list {\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n/* The language selector manages its own (viewport-based) height in styles.css\n   / responsive-styles.css. Keep the hover state identical to the resting state\n   so the list stays scrollable without resizing when the mouse enters/leaves. */\n.dropdown:hover .dropdown-list.lang-selector {\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n@media only screen and (max-width: 820px) {\n    .dropdown:hover .dropdown-list.lang-selector {\n        max-height: 77vh;\n    }\n}\n\n/* Dropdown form field (dropdownsingle / dropdownmulti) in the learner form modal */\n.dropdown-field {\n    width: 100%;\n    padding: 0;\n}\n.dropdown-field .dropdown-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    text-align: left;\n}\n.dropdown-field .dropdown-trigger.dropdown-placeholder .dropdown-trigger-label {\n    color: #858896;\n}\n/* Label shows the selected value(s) on a single line; the comma-separated multi-select\n   list is clipped with an ellipsis when it doesn't fit (the component then swaps in an\n   \"N selected\" summary via the hidden sizer below). min-width:0 lets it shrink inside\n   the flex trigger. */\n.dropdown-field .dropdown-trigger-label {\n    position: relative;\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n/* Off-screen sizer holding the full comma-separated list at its natural width so the\n   component can measure whether it would fit; never visible and never affects layout. */\n.dropdown-field .dropdown-label-sizer {\n    position: absolute;\n    left: 0;\n    top: 0;\n    visibility: hidden;\n    white-space: nowrap;\n    pointer-events: none;\n}\n/* CSS-drawn caret so the arrow renders regardless of icon-font coverage. */\n.dropdown-field .dropdown-chevron {\n    flex: 0 0 auto;\n    margin-left: 0.5rem;\n    width: 0;\n    height: 0;\n    border-left: 0.3125rem solid transparent;\n    border-right: 0.3125rem solid transparent;\n    border-top: 0.375rem solid currentColor;\n    transition: transform 0.15s ease;\n}\n.dropdown-field.open .dropdown-chevron {\n    transform: rotate(180deg);\n}\n/* This field opens on click (.open), not on hover. Neutralise the base hover rule. */\n.dropdown-field:hover .dropdown-list {\n    display: none;\n}\n.dropdown-field.open .dropdown-list {\n    display: block;\n    max-height: 320px;\n    overflow-y: auto;\n}\n.dropdown-field .dropdown-search {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n    border: none;\n    border-bottom: 1px solid var(--accent-1);\n}\n.dropdown-field.open .dropdown-list > div {\n    display: flex;\n    align-items: center;\n}\n/* Review mode: the menu can be opened to inspect selections, but options are not clickable. */\n.dropdown-field.open .dropdown-list > div.read-only {\n    cursor: default;\n}\n/* The read-only form disables pointer events on all inputs/buttons (.disable-fields). The\n   dropdown is the exception: reviewers must be able to open it and search to see the full\n   list of selected options, so re-enable interaction on the trigger and search input. */\n.disable-fields .dropdown-field .dropdown-trigger,\n.disable-fields .dropdown-field .dropdown-search {\n    pointer-events: auto;\n}\n.review-notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    /* Pull up under the tile (tile has margin-bottom: 1rem) and match its right margin */\n    margin: -0.5rem 2rem 1rem 0;\n    border-radius: 6px;\n    background: #fff6e5 !important;\n    border: 1px solid var(--warn);\n    color: inherit;\n    font-size: 0.85rem;\n    line-height: 1.35;\n}\n\n.review-notice i {\n    color: var(--warn);\n    font-size: 1.1rem;\n    flex-shrink: 0;\n    line-height: 1.2;\n}\n\n.review-notice__title {\n    font-weight: 600;\n}\n\n.review-badge {\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n    padding: 0.15rem 0.6rem;\n    border-radius: 4px;\n    background: var(--warn);\n    color: #4a3200;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
